import {
  FETCH_CLIENT,
  FETCH_CLIENT_SUCCESS,
  FETCH_CLIENT_FAILURE,
  GENERATE_CLIENT_CODE,
  GENERATE_CLIENT_CODE_SUCCESS,
  GENERATE_CLIENT_CODE_FAILURE, 
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  DELETE_CLIENT,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAILURE,
  CHANGE_CLIENT_STATUS,
  CHANGE_CLIENT_STATUS_SUCCESS,
  CHANGE_CLIENT_STATUS_FAILURE,
  FETCH_ACTIVE_CLIENT_REQUEST,
  FETCH_ACTIVE_CLIENT_SUCCESS,
  FETCH_ACTIVE_CLIENT_FAILURE,
  FETCH_TIMESHEET_GET_ACCOUNT_LIST,
  FETCH_TIMESHEET_GET_ACCOUNT_LIST_SUCCESS,
  FETCH_TIMESHEET_GET_ACCOUNT_LIST_FAILURE

} from "./actionTypes";

// Fetch Client
export const fetchClient = (unitId) => ({
  type: FETCH_CLIENT,
  payload: { unitId }
});

export const fetchClientSuccess = (roles) => ({
  type: FETCH_CLIENT_SUCCESS,
  payload: roles,
});

export const fetchClientFailure = (error) => ({
  type: FETCH_CLIENT_FAILURE,
  payload: error,
});

export const generateClientCode = (unitId) => ({
  type: GENERATE_CLIENT_CODE,
  payload: { unitId }
});

export const generateClientCodeSuccess = (roles) => ({
  type: GENERATE_CLIENT_CODE_SUCCESS,
  payload: roles,
});

export const generateClientCodeFailure = (error) => ({
  type: GENERATE_CLIENT_CODE_FAILURE,
  payload: error,
});

// Create Client
export const createClientRequest = (formData, isEdit) => ({
  type: CREATE_CLIENT_REQUEST,
  payload: { formData, isEdit },
});

export const createClientSuccess = (response) => ({
  type: CREATE_CLIENT_SUCCESS,
  payload: response,
});

export const createClientFailure = (error) => ({
  type: CREATE_CLIENT_FAILURE,
  payload: error,
});

export const changeClientStatus = (payload) => ({
  type: CHANGE_CLIENT_STATUS,
  payload,
});

export const changeClientStatusSuccess = (response) => ({
  type: CHANGE_CLIENT_STATUS_SUCCESS,
  payload: response,
});

export const changeClientStatusFailure = (error) => ({
  type: CHANGE_CLIENT_STATUS_FAILURE,
  payload: error,
});

// Delete Client
export const deleteClient = (formdata) => ({
  type: DELETE_CLIENT,
  payload: formdata,
});

export const deleteClientSuccess = (response) => ({
  type: DELETE_CLIENT_SUCCESS,
  payload: response,
});

export const deleteClientFailure = (error) => ({
  type: DELETE_CLIENT_FAILURE,
  payload: error,
});

export const fetchActiveClient = (unit_id) => ({
  type: FETCH_ACTIVE_CLIENT_REQUEST,
  payload: {unit_id},
});

export const fetchActiveClientSuccess = (data) => ({
  type: FETCH_ACTIVE_CLIENT_SUCCESS,
  payload: data,
});

export const fetchActiveClientFailure = (error) => ({
  type: FETCH_ACTIVE_CLIENT_FAILURE,
  payload: error,
});

export const fetchAccountList = (unit_id) => ({
  type: FETCH_TIMESHEET_GET_ACCOUNT_LIST,
  payload: { unit_id },
});

export const fetchAccountSuccess = (data) => ({
  type: FETCH_TIMESHEET_GET_ACCOUNT_LIST_SUCCESS,
  payload: data,
});

export const fetchAccountFailure = (error) => ({
  type: FETCH_TIMESHEET_GET_ACCOUNT_LIST_FAILURE,
  payload: error,
});